import { cn } from '@core-utils/cn';
import { createContext, forwardRef, useId } from 'react';

import styles from './Form.module.scss';

type FormItemContextValue = {
    id: string;
};

const FormItemContext = createContext<FormItemContextValue>(
    {} as FormItemContextValue,
);

const FormItem = forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(function FormItem({ className, ...props }, ref) {
    const id = useId();

    return (
        <FormItemContext.Provider value={{ id }}>
            <div
                ref={ref}
                className={cn(styles.FormItem, className)}
                {...props}
            />
        </FormItemContext.Provider>
    );
});

export { FormItem };
